import * as Icons from "@airhelp/icons";
import { Link } from "@chakra-ui/react";
import { useLanguage } from "contexts/LocalizationContext";
import NextLink from "next/link";
import { useLinkRelValue } from "hooks";
import type { FooterLinkProps } from "../types";
import { getLinkSource } from "../../globalComponents.utils";

const setLinkStyles = (isIconLink: boolean) =>
  isIconLink
    ? { color: "greyscale.500", hover: { color: "primary.500" } }
    : { color: "greyscale.600", hover: { color: "primary.500" } };

const iconSize = { svg: { boxSize: 6 } };

export const FooterLink = ({
  name,
  icon,
  footerLinkHideLinkForLanguages,
  footerLink,
}: FooterLinkProps) => {
  const relValue = useLinkRelValue(getLinkSource(footerLink));
  const language = useLanguage();
  if (footerLinkHideLinkForLanguages && footerLinkHideLinkForLanguages.includes(language)) return null;
  const Icon = Icons[icon];
  const { hover, color } = setLinkStyles(Boolean(Icon));

  return (
    <Link
      data-testid="footer-elements"
      as={NextLink}
      href={getLinkSource(footerLink)}
      rel={relValue}
      fontSize="sm"
      fontWeight="normal"
      color={color}
      _hover={hover}
      sx={iconSize}
    >
      {name || (icon && <Icon />)}
    </Link>
  );
};
